import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Render-component voor een kernwoorden-rij: een sectiekop ("Kernwoorden") +
 * een wrap-able lijst van chip-elementen. Stateless en herbruikbaar — krijgt
 * de items als string-array en de label als string. Geen items → component
 * rendert helemaal niets.
 */
@Component({
  selector: 'hd-circuit-info-kernwoorden',
  templateUrl: './hd-circuit-info-kernwoorden.component.html',
  styleUrl: './hd-circuit-info-kernwoorden.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class HdCircuitInfoKernwoordenComponent {
  /** Sectiekop boven de chips, bv. "Kernwoorden". Leeg → geen kop. */
  readonly label = input<string>('');

  /** Lijst van kernwoorden. Lege lijst → component rendert niets. */
  readonly items = input.required<readonly string[]>();

  protected readonly hasItems = computed(() => this.items().length > 0);
}
